import React from 'react'
import Header from '../common/Header'
import Footer from '../common/Footer'

const AboutUs = () => {
    window.scrollTo(0, 0);
  return (
    <>
      <Header/>
      <div className='bgtheme py-4 h4 text-white text-center'>About Us</div>

      <div className="container my-5">
        <h4>1. Who We Are</h4>
        <p>
          We are a passionate team dedicated to building a platform that makes booking services 
          easier and faster for everyone. Our goal is to connect users with trusted service providers.
        </p>

        <h4 className='mt-5'>2. Our Mission</h4>
        <p>
          To simplify service booking through innovative technology and customer-focused solutions.
        </p>

        <h4 className='mt-5'>3. Our Vision</h4>
        <p>
          To become the leading platform for all types of services, empowering people and businesses worldwide.
        </p>

        <h4 className='mt-5'>4. Our Team</h4>
        <p>
          We are a diverse team of developers, designers, and support staff who are passionate 
          about improving lives through technology.
        </p>
      </div>

      <Footer/>
    </>
  )
}

export default AboutUs
